import { View } from "../types/view";

export const views: View[] = [
    {
        viewName: "Billing",
        queueName: "Billing",
        ordersTable: {
            columns: [
                "orderNumber",
                "orderStatus",
                "billerCode",
                "billToCode",
                "isLumper",
                "docRequirementMet",
                "docStatus",
                "emptyCallDate",
            ],
        },
        orderStatuses: ["E"],
    },
    {
        viewName: "Billing Complete",
        queueName: "Billing Complete",
        ordersTable: {
            columns: [
                "orderNumber",
                "orderStatus",
                "billerCode",
                "billToCode",
                "docRequirementMet",
                "docStatus",
                "emptyCallDate",
            ],
        },
        orderStatuses: ["E"],
    },
    {
        viewName: "Billing Hold",
        queueName: "Billing Hold",
        ordersTable: {
            columns: [
                "orderNumber",
                "orderStatus",
                "billerCode",
                "billToCode",
                "docRequirementMet",
                "docStatus",
                "emptyCallDate",
            ],
        },
        orderStatuses: ["E"],
    },
    {
        viewName: "Rating",
        queueName: "Rating",
        ordersTable: {
            columns: [
                "orderNumber",
                "orderStatus",
                "billerCode",
                "billToCode",
                "isAccurateBillTo",
                "hasRateID",
                "hasRCS",
                "hasSBL",
                "isEdiBillingCustomer",
                "emptyCallDate",
            ],
        },
        orderStatuses: [],
    },
    {
        viewName: "Customer Account",
        queueName: "Customer Account",
        ordersTable: {
            columns: [
                "orderNumber",
                "orderStatus",
                "billerCode",
                "billToCode",
                "csrCode",
                "hasRateID",
                "hasRCS",
                "hasSBL",
                "isAccurateBillTo",
                "isEdiBillingCustomer",
                "daysEmpty",
                "emptyCallDate",
                "teamName",
            ],
        },
        orderStatuses: [],
    },
    {
        viewName: "Fleet",
        queueName: "Fleet",
        ordersTable: {
            columns: [
                "orderNumber",
                "orderStatus",
                "billerCode",
                "billToCode",
                "hasSBL",
                "isLumper",
                "emptyCallDate",
                "emptyFleet",
                "emptyDriver",
                "daysEmpty",
                "isLumper",
            ],
        },
        orderStatuses: ["E"],
    },
];
